// extracted by mini-css-extract-plugin
export default {"container":"InqueryInfo_container__rzwHA","content":"InqueryInfo_content__eqAGO","inner":"InqueryInfo_inner__NbKv1","no-bullet":"InqueryInfo_no-bullet__q2Xln"};